import { isLocal } from '~/shared/utils/environments';

import { StylesheetManager } from './types';

const TAILWIND_IDENTIFIERS = ['*,:after,:before', '*, ::before, ::after'];

/**
 * Implementation of StylesheetManager for browser environment
 * Temporarily removes Tailwind styles during printing and restores them afterward
 * Works in both development (style tags) and production (stylesheet links) environments
 */
export const createStylesheetManager = (): StylesheetManager => {
  return {
    disableTailwindStyles: () => {
      const removedStyleElements: (HTMLStyleElement | HTMLLinkElement)[] = [];

      try {
        // Handle inline style tags (development mode)
        const styleTags = Array.from(document.head.querySelectorAll('style'));
        styleTags.forEach(styleTag => {
          if (isLocal()) {
            const content = styleTag.textContent || '';
            const isTailwindStylesheet = TAILWIND_IDENTIFIERS.some(identifier =>
              content.includes(identifier)
            );

            if (isTailwindStylesheet) {
              removedStyleElements.push(styleTag);
              styleTag.remove();
            }
          }
        });

        // Handle linked stylesheets (production mode)
        if (!isLocal()) {
          const linkTags = Array.from(
            document.head.querySelectorAll('link[rel="stylesheet"]')
          );
          linkTags.forEach(linkTag => {
            if (linkTag.getAttribute('href')) {
              removedStyleElements.push(linkTag as HTMLLinkElement);
              linkTag.remove();
            }
          });
        }
      } catch (error) {
        console.error('Failed to manage stylesheet visibility:', error);
      }

      return {
        restore: () => {
          // Restore all removed style elements (both styles and links)
          removedStyleElements.forEach(element => {
            document.head.appendChild(element);
          });
        },
      };
    },
  };
};
